import InternalRequests from "@/views/apps/internal_requests/InternalRequests.vue";

import layouts from "@/layout";
import Kpi from "../../views/apps/internal_requests/KPI/Kpi";
import training from "../../views/apps/cmi/training/mview/index";
import DocumentList from "../../views/apps/internal_requests/documents/DocumentList";
import store from "@/store";
import channelMview from "../../views/apps/cmi/training/mview/channelMview.vue";
import roles from "@/roles";
import { COMPANYS } from "@/const";
import TasksReport from "@/views/apps/internal_requests/KPI/TasksReport/TasksReport";
import ServiceRequestTypesAndSLAConfigurations from "@/views/apps/internal_requests/managment/ServiceRequestTypesAndSLAConfigurations.vue";

export default {
  path: "/internal-requests",
  name: "internalRequests",
  component: InternalRequests,
  meta: {
    auth: true,
    searchable: true,
    layout: layouts.navLeft,
    title: "Mis Solicitudes",
    tags: ["flow", "activity", "activity_flow"]
  },
  redirect: {
    name: "MisSolicitudesIndex"
  },
  children: [
    {
      path: "",
      alias: "/",
      name: "internalRequestsIndex",
      component: () =>
        import("@/views/apps/internal_requests/requests/index.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Mis Solicitudes",
        tags: ["flow", "activity", "activity_flow"],
        index: true
      }
    },

    // {
    //   path: "/cmi",
    //   name: "cmi",
    //   component: () =>
    //     import(/* webpackChunkName: "cmi" */ "../../views/apps/cmi/Cmi.vue"),
    //   meta: {
    //     auth: true
    //   },
    //   children: [
    //     {

    //     }
    //   ]
    // },
    {
      path: "documents",
      name: "internal-requests-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["internal-requests", "documents"],
        index: true
      }
    },
    {
      path: "training",
      name: "training-cmi",
      component: training,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Entrenamientos",
        tags: ["training"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "cmi-link-channel-magynet",
          name: "cmi-training-link-channel-magynet",
          component: channelMview,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Canal de Youtube",
            tags: ["sales", "training", "channelMview"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          }
        }
      ]
    },
    {
      path: "kpislaInternal",
      name: "kpislaInternal",
      component: Kpi,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI",
        tags: ["support", "kpi"],
        index: true
      },
      children: [
        {
          path: "kpi-per-support-internal",
          name: "internal-requests-kpi-per-support",
          component: () =>
            import("../../views/apps/internal_requests/KPI/SLA/KPISLA.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "KPI Cumplimiento SLA",
            tags: ["support", "sla", "list"],
            index: true
          }
        },
        {
          path: "kpi-per-satisfactions-internal",
          name: "internal-requests-kpi-per-satisfactions",
          component: () =>
            import(
              "../../views/apps/internal_requests/KPI/Satisfaccion/KpiSatisfaccionGeneral.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Satisfactions KPI",
            tags: ["support", "sla", "list"],
            index: true
          }
        },
        {
          path: "Report-per-Responsable-internal",
          name: "internal-requests-report-per-responsable",
          component: () =>
            import(
              "../../views/apps/internal_requests/KPI/InternalRequestbyResponsable.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte de Solicitudes Internas",
            tags: ["support", "sla", "list"],
            index: true
          }
        }
      ]
    },
    {
      path: "Tasks-Report",
      name: "Tasks-Report",
      component: TasksReport,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reporte de Tareas",
        tags: ["support", "tasks", "list"],
        index: true
      }
    },
    {
      path: "Service-Request-Types-And-SLA-Configurations",
      name: "Service-Request-Types-And-SLA-Configurations",
      component: ServiceRequestTypesAndSLAConfigurations,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Configuración de Tipos de Solicitud y SLA",
        tags: ["support", "service-requests", "sla"],
        index: true
      }
    }
  ]
};
